import Dashboard from "../component/dashboard";
import ForgotPassword from "../component/forgot-password";
import Home from "../component/home";
import Login from "../component/login";
import Register from "../component/register";
import ResetPassword from "../component/reset-password";
import Verification from "../component/verification";
import NewProposalForm from "../component/dashboard/new-proposal/NewProposalForm";
import ProposalUnderProgress from "../component/dashboard/proposal-under-progress";
import SubmittedProposal from "../component/dashboard/submitted-proposal";
import ClaimHistory from "../component/dashboard/claim-history";
import IssuedPolicy from "../component/dashboard/issued-policy";
import Profile from "../component/dashboard/profile";
import JewelersBlock from "../component/jewelers-block/JewelersBlock";
import AboutUs from "../component/about-us/AboutUs";
import ContactUs from "../component/contact-us/ContactUs";
import MPayment from "../component/mpayment";
import EndorsementsList from "../component/dashboard/endorsements";
import ExhibitionCoverage from "../component/dashboard/Exhibition-coverage/Index";
import Checkout from "../component/checkout/Checkout";
import Clients from "../component/dashboard/clients";
import ClientSelect from "../component/client-select";
import DetailsComponent from "../component/details-page/Details";
import DocuSignCallback from "../component/docusign-callback/DocusignCallback";
import DocusignInitiate from "../component/docusign-initiate/DocusignInitiate";
import Success from "../component/sucess/Success";
import ClientRegister from "../component/dashboard/client-register";
import DiamondForm from "../component/dashboard/diamond-form";
import JewelersBlockPolicy from "../component/jewelers-block-policy/JewelersBlockPolicy";

export const RoutesData = [
  {
    path: "/",
    isRestricted: false,
    isAuthenticated: false,
    exact: false,
    element: <Home />,
  },
  {
    path: "/login",
    isRestricted: true,
    isAuthenticated: false,
    exact: false,
    element: <Login />,
  },
  {
    path: "/register",
    isRestricted: true,
    isAuthenticated: false,
    exact: false,
    element: <Register />,
  },
  {
    path: "/forgot-password",
    isRestricted: true,
    isAuthenticated: false,
    exact: false,
    element: <ForgotPassword />,
  },
  {
    path: "/verification/:type/:uid",
    isRestricted: true,
    isAuthenticated: false,
    exact: true,
    element: <Verification />,
  },
  {
    path: "/details/:type/:uid",
    isRestricted: false,
    isAuthenticated: true,
    exact: true,
    element: <DetailsComponent />,
  },
  {
    path: "/reset-password/:uid",
    isRestricted: true,
    isAuthenticated: false,
    exact: true,
    element: <ResetPassword />,
  },
  {
    path: "/dashboard",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <Dashboard />,
  },
  {
    path: "/new-proposal",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <NewProposalForm />,
  },
  {
    path: "/diamond-form",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <DiamondForm />,
  },
  {
    path: "/proposal-under-progress",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <ProposalUnderProgress />,
  },
  {
    path: "/submitted-proposal",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <SubmittedProposal />,
  },
  {
    path: "/claim-history",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <ClaimHistory />,
  },
  {
    path: "/clients",
    isRestricted: false,
    isAuthenticated: true,
    exact: true,
    element: <Clients />,
  },
  // {
  //   path: "/clients/:type",
  //   isRestricted: false,
  //   isAuthenticated: true,
  //   exact: true,
  //   element: <Clients />,
  // },
  {
    path: "/client-registration",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <ClientRegister />,
  },
  {
    path: "/issued-policy",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <IssuedPolicy />,
  },
  {
    path: "/endorsements",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <EndorsementsList />,
  },
  {
    path: "/exhibition-coverage",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <ExhibitionCoverage />,
  },
  {
    path: "/profile",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <Profile />,
  },
  {
    path: "/jewelers-block",
    isRestricted: false,
    isAuthenticated: false,
    exact: false,
    element: <JewelersBlock />,
  },
  {
    path: "/about-us",
    isRestricted: false,
    isAuthenticated: false,
    exact: false,
    element: <AboutUs />,
  },
  {
    path: "/jewelers-block-policy",
    isRestricted: false,
    isAuthenticated: false,
    exact: false,
    element: <JewelersBlockPolicy />,
  },
  {
    path: "/contact-us",
    isRestricted: false,
    isAuthenticated: false,
    exact: false,
    element: <ContactUs />,
  },
  {
    path: "/m-payment",
    isRestricted: false,
    isAuthenticated: false,
    exact: false,
    element: <MPayment />,
  },
  {
    path: "/checkout",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <Checkout />,
  },
  {
    path: "/client-select",
    isRestricted: false,
    isAuthenticated: true,
    exact: false,
    element: <ClientSelect />,
  },
  {
    path: "/docusign-initiate",
    isRestricted: false,
    isAuthenticated: false,
    exact: false,
    element: <DocusignInitiate />,
  },
  {
    path: "/docusign/callback",
    isRestricted: false,
    isAuthenticated: false,
    exact: false,
    element: <DocuSignCallback />,
  },
  {
    path: "/docusign/success",
    isRestricted: false,
    isAuthenticated: false,
    exact: false,
    element: <Success />,
  },
];
